export const HIKVISION_PLAY_AUDIO_ACTION = "play_audio";
export const LEGACY_HIKVISION_PLAY_AUDIO_ACTION = "hikvision_play_audio";

export const normalizeHikvisionPlayAudioAction = (action) =>
	action === LEGACY_HIKVISION_PLAY_AUDIO_ACTION
		? HIKVISION_PLAY_AUDIO_ACTION
		: action;

const normalizeText = (value) =>
	value === undefined || value === null ? "" : String(value).trim();

export const isHikvisionAccessTerminal = (device) => {
	if (!device || typeof device !== "object") return false;
	return normalizeText(device.vendor).toLowerCase() === "hikvision";
};

export const isEligibleSpeakerTerminal = (device) => {
	if (!isHikvisionAccessTerminal(device)) return false;
	const capabilities = device.speakerCapabilities || {};
	return device.speakerEligible === true && capabilities.twoWayAudio === true;
};

export const normalizeSoundUrlPath = (urlPath, baseUrl = "") => {
	const value = normalizeText(urlPath);
	if (!value || value.startsWith("file:")) return "";
	if (value.startsWith("/")) return value;

	const base = normalizeText(baseUrl);
	if (base && value.startsWith(base)) {
		const stripped = value.slice(base.length);
		return stripped.startsWith("/") ? stripped : `/${stripped}`;
	}

	try {
		const url = new URL(value);
		return `${url.pathname}${url.search}${url.hash}`;
	} catch (e) {
		return value.includes("://") ? "" : value;
	}
};

export const normalizeSpeakerSoundPayload = (sound, baseUrl = "") => {
	if (!sound || typeof sound !== "object") return null;
	const soundId =
		sound.soundId !== undefined && sound.soundId !== null
			? sound.soundId
			: sound.id !== undefined && sound.id !== null
				? sound.id
				: sound.key;
	const name = normalizeText(sound.name || sound.text || sound.filename);
	const url_path = normalizeSoundUrlPath(
		sound.url_path ||
			sound.urlPath ||
			sound.relativeUrlPath ||
			sound.path ||
			sound.url ||
			sound.file ||
			sound.src,
		baseUrl,
	);

	if (!name || !url_path) return null;

	return {
		soundId:
			soundId === undefined || soundId === null || soundId === ""
				? name
				: soundId,
		name,
		url_path,
	};
};

export const parseHikvisionPlayAudioValue = (value) => {
	if (!value) return null;
	if (typeof value === "object")
		return normalizeSpeakerSoundPayload(value) || value;
	if (typeof value !== "string") return null;

	try {
		const parsed = JSON.parse(value);
		return parsed && typeof parsed === "object" ? parsed : null;
	} catch (e) {
		return null;
	}
};

export const buildHikvisionPlayAudioValue = (sound, baseUrl = "") => {
	const payload = normalizeSpeakerSoundPayload(sound, baseUrl);
	return payload ? JSON.stringify(payload) : "";
};
